module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "not-found"
    }
  }, [_c('h1', [_vm._v("Not found ... ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-89c61404!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 344
// module chunks = 2